class Wishlist {
    constructor() {
        this.customer_id = window.customerDetails?.id || null;
        this.cartElement = document.querySelector('cart-form');
        this.renderWishlist();
    }

    async renderWishlist() {
        if (this.customer_id) {
            const storedWishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            if (storedWishlist.items.length) {
                const items = storedWishlist.items.map(item => ({
                    customer_id: this.customer_id ? parseInt(this.customer_id, 10) : null,
                    variant_id: item.variant_id,
                    product_id: item.product_id,
                    line_item_properties: item.line_item_properties || {}, 
                    shop: "diamondrensu-uk.myshopify.com",
                    product_title: item.product_title, 
                    handle: item.handle,
                    item_qty: item.item_qty, 
                    image: item.image,
                    type: item.type,
                    product_price: item.product_price, 
                    product_compare_price: item.product_compare_price, 
                    is_save_later: item.is_save_later 
                }));
                await this.addToWishlist(items); 
            }
    
            const endpoint = `https://certificate-manager.diamondrensu.com/api/wishlist?customer_id=${this.customer_id}`;
            try {
                const response = await fetch(endpoint, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shop': 'diamondrensu-uk.myshopify.com',
                    }
                });
            
                if (!response.ok) {
                    if (response.statusText === 'Not Found' || response.status === 404) {
                        document.querySelector('.wishlist-loading')?.classList.add('d-none');
                        document.querySelector('.custom-wishlist-empty')?.classList.remove('d-none');
                    }
                    
                }
                const textData = await response.text();
                
                try {
                    const parsedData = JSON.parse(textData);
                    
                    this.data = parsedData.data.data;
                    this.paginationData = parsedData.data.links;
                    this.renderwishlistgrid(this.data,this.paginationData);
                } catch (parseError) {
                    console.error("Error parsing JSON:", parseError);
                }
            } catch (error) {
                console.error('Error:', error);
            }
            
        }
    }
    

    async addToWishlist(items) {
        const endpoint = "https://certificate-manager.diamondrensu.com/api/wishlist/addbulkwishlist";
    
        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shop': 'diamondrensu-uk.myshopify.com',
                },
                body: JSON.stringify({ items })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            
            const storedWishlist = JSON.parse(localStorage.getItem('wishlist')) || { items: [] };
            const remainingItems = storedWishlist.items.filter(item =>
                !items.some(addedItem => addedItem.variant_id === item.variant_id)
            );
            localStorage.setItem('wishlist', JSON.stringify({ items: remainingItems }));
    
        } catch (error) {
            console.error('Error:', error);
        }
    }
    
    
    
    renderwishlistgrid(items, paginationData) {
        this.gridHTML = ``;
        this.paginationHTML = ``;
        const paginationContainer = document.querySelector('.pagination-container');
    
        // Clear previous pagination
        paginationContainer.innerHTML = '';
    
        // Show "Previous" button only if more than 4 links
        if (paginationData != null) {
        if (paginationData.length > 4) {
            const prevPage = paginationData.find(page => page.label === "&laquo; Previous");
            if (prevPage) {
                const prevElement = document.createElement('li');
                prevElement.classList.add('page-item');
                const prevLink = document.createElement('a');
                prevLink.classList.add('page-link');
                prevLink.href = prevPage.url || '#';
                prevLink.innerHTML = "&laquo; Previous";
                prevLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (prevPage.url) {
                        this.fetchWishlistData(`${prevPage.url}&customer_id=${this.customer_id}`);
                    }
                });
                prevElement.appendChild(prevLink);
                paginationContainer.appendChild(prevElement);
            }
        }
    
        // Render pagination links
        paginationData
            .filter(page => page.label !== "&laquo; Previous" && page.label !== "Next &raquo;") // Exclude "Next" and "Previous" here
            .forEach(page => {
                const pageElement = document.createElement('li');
                pageElement.classList.add('page-item');
    
                if (page.active) {
                    pageElement.classList.add('active');
                }
    
                const pageLink = document.createElement('a');
                pageLink.classList.add('page-link');
                pageLink.href = page.url || '#';
                pageLink.innerHTML = page.label;
    
                pageLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (page.url) {
                        this.fetchWishlistData(`${page.url}&customer_id=${this.customer_id}`);
                    }
                });
    
                pageElement.appendChild(pageLink);
                paginationContainer.appendChild(pageElement);
            });
    
        // Show "Next" button only if more than 4 links
        if (paginationData.length > 4) {
            const nextPage = paginationData.find(page => page.label === "Next &raquo;");
            if (nextPage) {
                const nextElement = document.createElement('li');
                nextElement.classList.add('page-item');
                const nextLink = document.createElement('a');
                nextLink.classList.add('page-link');
                nextLink.href = nextPage.url || '#';
                nextLink.innerHTML = "Next &raquo;";
                nextLink.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (nextPage.url) {
                        this.fetchWishlistData(`${nextPage.url}&customer_id=${this.customer_id}`);
                    }
                });
                nextElement.appendChild(nextLink);
                paginationContainer.appendChild(nextElement);
            }
        }
    }
        if (items != undefined) {
            items.forEach(item => {
                let ProertiesDetails = item.line_item_properties; 
                let propertiesHTML = '';
        
                // Clean and format line_item_properties
                const cleanObject = {};
                if (ProertiesDetails != null) {
                    Object.entries(ProertiesDetails).forEach(([key, value]) => {
                        const cleanedKey = key.replace(/^properties\[(.*?)\]$/, '$1');
                        cleanObject[cleanedKey] = value;
                    });    
                }
                
                Object.entries(cleanObject).forEach(([key, value]) => {
                    if ((value !== null && value !== undefined && value !== "")) {
                        propertiesHTML += `
                        <div>
                            <strong>${key}:</strong> ${value}
                        </div>
                    `;    
                    }
                });
        
                // Discount calculation
                var discount_html = ``;
                if (item.product_price && item.product_compare_price) {
                    const compareAtPrice = parseInt(item.product_compare_price);
                    const price = parseInt(item.product_price);
        
                    const priceDifference = compareAtPrice - price;
                    const discountPercentage = Math.round((priceDifference * 100) / compareAtPrice);
                    if (discountPercentage > 0) {
                        discount_html = `<span class="discount-percentage text-primary-500 ms-auto bg-primary-200 p-1 rounded fs-md fw-semibold">(${discountPercentage}% off)</span>`;
                    }
                }
                var comapreAtHTML = ``;
                if (item.product_compare_price != null ) {
                    comapreAtHTML =` <s class="fs-md m-0 p-0 discount-price fs-md money" data-compareprice="">${Utility.formatMoney(item.product_compare_price, window.globalSpace.money_format)}</s> ` ;
                }
                this.gridHTML += `
                    <div class="col-6 col-xl-3 col-md-4 col-sm-6 mt-5 mt-lg-7 px-2 px-md-3 d-flex align-items-stretch justify-content-around">
                    <div class="card card-product card-product-style-1 text-start rounded-0 border-0 position-relative" data-product-grid="">
                        <div data-remove-from-wishlist data-productid="${item.product_id}" data-var_id="${item.variant_id}" class="removefromwishlist bg-white end-0 p-2 position-absolute rounded-circle d-flex justify-content-center m-1">
                            <svg aria-hidden="true" focusable="false" style="width:10px;height:10px;">
                                <use href="#icon-close"></use>
                            </svg>
                        </div>
                        <div class="card-img text-center position-relative ">
                        <a href="/products/${item.handle}" class="d-block product-link">
                          <picture class="position-absolute w-100 h-100 top-0 start-0">
                                <img src="${item.image}" loading="lazy" class="w-100" alt="certified diamond rings" title="certified diamond rings" data-hoverimage="" width="2048" height="2048">
                            </picture></a></div>
                
                  <div class="card-body px-0">
                    <div class="row no-gutter h-100">
                        <div class="col-12">
                          <p class="card-title mb-2 font-family-base">
                            <a class="product-link" role="button" href="/products/${item.handle}">${item.product_title}</a>
                          </p>
                        </div>
                        
                        <a href="/products/${item.handle}" class="col-12 d-flex align-items-center flex-wrap">
                            <span class="price m-0 p-0 money me-2 fw-semibold" data-currentprice="">${Utility.formatMoney(item.product_price, window.globalSpace.money_format)}</span>                
                            ${comapreAtHTML}
                            ${discount_html}</a>
                        
                    </div>
                    </div>
                    <div class="col-12 mt-auto">
                    <a class="product-link btn btn-primary w-100 px-2" role="button" href="/products/${item.handle}">Complate Purchase</a> 
                        </div>
                  
                </div>
                </div>
                `;
            });
            document.querySelector(".wishlist-grid").innerHTML = this.gridHTML;
            document.querySelectorAll('[data-remove-from-wishlist]').forEach(button => button.addEventListener('click', this.removeFromwishlist.bind(this)));
            document.querySelectorAll('[data-add-cart]').forEach(button => button.addEventListener('click', this.moveWishlistItemToCart.bind(this)));    
        } else {
            document.querySelector('.wishlist-grid').innerHTML= ``;
            document.querySelector('.custom-wishlist-empty')?.classList.remove('d-none');
        }
    }
    
    
    async fetchWishlistData(url) {
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shop': 'diamondrensu-uk.myshopify.com',
                }
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            this.paginationData = data.data.links;
            this.renderwishlistgrid(data.data.data,this.paginationData); 
        } catch (error) {
            console.error('Error fetching wishlist:', error);
        }
    }

    removeFromwishlist(event){
        let currentTarget = event.currentTarget;
        const endpoint = "https://certificate-manager.diamondrensu.com/api/wishlist/remove";
        const body = {
            customer_id: this.customer_id,
            product_id: currentTarget.dataset.productid,
            variant_id: currentTarget.dataset.var_id
        };

        

        fetch(endpoint, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'X-Shop': 'diamondrensu-uk.myshopify.com',
            },
            body: JSON.stringify(body)
        })
        .then(response => response.json())
        .then(data => {
            this.renderWishlist();
        })
        .catch(error => {
            console.error("Error:", error);
        });
    }

    moveWishlistItemToCart(event) {
        let currentTarget = event.currentTarget;
        currentTarget.classList.add('loading');
        
        // Parse properties from the dataset
        let properties = JSON.parse(currentTarget.dataset.properties);

        delete properties["Metal Type"];

        delete properties["Diamond Size"];

        let body = JSON.stringify({
            id: currentTarget.dataset.variantid,
            quantity: 1,
            properties: properties // Pass properties as an object
        });
    
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
            .then((response) => response.json())
            .then(() => {
                currentTarget.classList.remove('loading');
                this.cartElement.getCartData('open_drawer');
            })
            .catch((e) => {
                console.error(e);
                Rollbar.error(`Failed to add the product from wishlist page - ${e}`);
            })
            .finally(() => {
                currentTarget.removeAttribute('disabled');
            });
    }
    
}


typeof Wishlist !== 'undefined' && new Wishlist();
